import { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import InfoOverlay from '../../../components/InfoOverlay';
import RaceClassDropdown from '../../../components/RaceClassDropdown';
import RegistrationBtnGroup from './RegistrationBtnGroup';

function RegistrationCard({
  registration,
  status,
  setRegistrations,
  batchSelectedRegistrations,
  setBatchSelectedRegistrations,
}) {
  return (
    <Card>
      <Card.Body>
        <div className='d-flex gap-2 align-items-center justify-content-between'>
          <div className='d-flex align-items-center'>
            <span className='bg-secondary-black text-white p-1 me-2'>
              {registration.racingNumber}
            </span>
            <InfoOverlay
              name={registration.name}
              info={registration.participantDetails}
              unRegistered={registration.unRegistered}
              participantInfo={true}
            />
          </div>
          <div className='d-flex gap-1'>
            <p className='d-none d-sm-flex me-2 text-secondary'>
              Tävlingsklass
            </p>
            <RaceClassDropdown
              value={registration.raceClass}
              status={status}
              setRegistrations={setRegistrations}
              email={registration.participantDetails?.email}
              participantId={registration.participantId}
              disabled={registration.unRegistered}
            />
          </div>
        </div>
        <div className='d-flex justify-content-between pt-2'>
          <span className='text-secondary'>Klubb</span>
          <span>
            {registration.clubAffiliation
              ? registration.clubAffiliation
              : 'Ej angett'}
          </span>
        </div>
        <div className='d-flex justify-content-between pt-2'>
          <span className='text-secondary'>Anmälare</span>
          <span>
            {registration.supporter ? (
              <InfoOverlay
                name={registration.supporter.name}
                info={registration.supporter}
                supporterInfo={true}
              />
            ) : (
              'Ej angett'
            )}
          </span>
        </div>
        <div className='d-flex justify-content-between pt-2'>
          <span className='text-secondary'>Övrig info</span>
          <span>
            {registration.miscellaneous ? (
              <InfoOverlay info={registration.miscellaneous} miscInfo={true} />
            ) : (
              'Ej angett'
            )}
          </span>
        </div>
        <Card.Footer
          className='mt-2'
          style={{ paddingRight: '0.5rem', paddingLeft: '0.5rem' }}
        >
          <div className='d-flex justify-content-between'>
            <div className='d-flex gap-2 align-items-center'>
              <input
                id={registration.racingNumber}
                type='checkbox'
                checked={batchSelectedRegistrations.some(
                  (r) =>
                    parseInt(r.racingNumber) ===
                    parseInt(registration.racingNumber)
                )}
                disabled={status !== 'Kommande' && status !== 'Pågående'}
                onChange={() => {
                  let newArr = [...batchSelectedRegistrations];

                  if (
                    newArr.some(
                      (r) => r.racingNumber === registration.racingNumber
                    )
                  ) {
                    newArr = newArr.filter(
                      (r) => r.racingNumber !== registration.racingNumber
                    );
                  } else {
                    newArr = [...newArr, registration];
                  }
                  setBatchSelectedRegistrations(newArr);
                }}
              />
              <label htmlFor={registration.racingNumber}>Markera</label>
            </div>

            <RegistrationBtnGroup
              status={status}
              participantId={registration.participantId}
              email={registration.participantDetails?.email}
              unRegistered={registration.unRegistered}
              inStartlist={registration.inStartlist}
              setRegistrations={setRegistrations}
            />
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default RegistrationCard;
